import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { userHooks } from "../hooks";
const Login = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // API 요청 (백엔드에 맞게 URL 수정 필요)
      const response = await userHooks.loginHooks({
        userId: values.username,
        password: values.password,
      });
      // 토큰 저장
      if (response.IsError) {
        throw new Error("login failed");
      }
      window.sessionStorage.setItem("accessToken", response.data.access_token);
      window.sessionStorage.setItem(
        "refreshToken",
        response.data.refresh_token
      );
      window.sessionStorage.setItem("login", "loggin");
      message.success("로그인 성공!");
      window.location.href = "/";
    } catch (error) {
      message.error("로그인 실패! 아이디와 비밀번호를 확인해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div style={{ width: 300 }}>
        <h2 style={{ textAlign: "center" }}>I'm Comming Admin</h2>
        <Form name="login" onFinish={onFinish}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "아이디를 입력해주세요!" }]}
          >
            <Input placeholder="아이디" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "비밀번호를 입력해주세요!" }]}
          >
            <Input.Password placeholder="비밀번호" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              로그인
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
